import type React from 'react'

import { Toggle } from '@/components/ui/Toggle.tsx'
import { classNames } from '@/utils/helpers'

export interface ToggleSectionProps {
  children: React.ReactNode
  label?: string
  labelFor?: string
  enabled: boolean
  onToggle: () => void
  className?: string
}

export const ToggleSection = (props: ToggleSectionProps) => {
  const { children, label, labelFor, enabled, className, onToggle } = props

  return (
    <div className={classNames('flex flex-col gap-2', className)}>
      <div className="flex items-center justify-between">
        {label && (
          <label
            htmlFor={labelFor}
            className="text-sm font-medium text-title"
          >
            {label}
          </label>
        )}
        <span className="flex items-center gap-4">
          <span className="text-sm font-medium text-title">Activate</span>
          <Toggle
            name={labelFor}
            checked={enabled}
            onChange={onToggle}
          />
        </span>
      </div>
      {enabled && children}
    </div>
  )
}
